import { render, staticRenderFns } from "./favorable.vue?vue&type=template&id=4960c977&scoped=true&"
import script from "./favorable.vue?vue&type=script&lang=js&"
export * from "./favorable.vue?vue&type=script&lang=js&"
import style0 from "./favorable.vue?vue&type=style&index=0&id=4960c977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4960c977",
  null
  
)

export default component.exports